import { Navigate } from "react-router-dom";

const ShippingAddress = () => {
    return <Navigate to="/checkout" replace />;
};

export default ShippingAddress;
